import { get, post } from '@/utils/request1';

export const usersLogin = (data) => post('user/login',data); // 登录
export const usersRegister = (data) => post('user/register',data); // 注册